import React from "react";
import { FaLaptopCode } from "react-icons/fa";
import { RiAppsLine } from "react-icons/ri";
import { DiJavascript1 } from "react-icons/di";
import { FaServer } from "react-icons/fa";
import { FaDatabase } from "react-icons/fa";
import { MdUpdate } from "react-icons/md";

import ServicesCard from "./ServicesCard";

const MyServices = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2">
      <ServicesCard
        icons={<FaLaptopCode />}
        title="Responsive Website Design & Development"
        subTitle="I create beautiful, responsive websites using HTML, CSS, and Bootstrap, ensuring that your site looks great on any device, from mobile to desktop. Whether you need a personal portfolio, a landing page, or a small business website, I can design and build a site tailored to your needs with a modern and user-friendly layout."
      />
      <ServicesCard
        icons={<RiAppsLine />}
        title=" Custom Web Application Development"
        subTitle="Need a custom web app? I develop lightweight, efficient web applications using React.js for the frontend and Node.js with Express on the backend. From simple tools to more complex interactive platforms, I ensure that your application is fast, secure, and scalable to meet your business requirements."
      />
      <ServicesCard
        icons={<DiJavascript1 />}
        title="Frontend Web Development"
        subTitle="I specialize in creating clean, dynamic frontends using React.js and JavaScript. My goal is to provide smooth, interactive user experiences with efficient, well-structured code. Whether you're looking for an interactive dashboard, a SPA (Single Page Application), or other UI solutions, I've got you covered."
      />
      <ServicesCard
        icons={<FaServer />}
        title="Backend API Development"
        subTitle="I build secure and scalable backend systems using Node.js and Express. Whether it's creating APIs for web or mobile applications, I ensure that your data flows smoothly between users and servers, ensuring reliability and performance."
      />
      <ServicesCard
        icons={<FaDatabase />}
        title="Simple Database Management (SQLite)"
        subTitle="Need a lightweight, easy-to-manage database? I design and maintain efficient SQLite databases for small-scale applications. From schema creation to query optimization, I ensure your data is organized and quickly accessible."
      />
      <ServicesCard
        icons={<MdUpdate />}
        title="Website Maintenance & Updates"
        subTitle="I offer ongoing maintenance services to keep your website up-to-date, running smoothly, and free from bugs. This includes regular updates, security checks, and performance optimization to ensure your site remains fast and functional."
      />
    </div>
  );
};

export default MyServices;
